import { Injectable, NgZone } from '@angular/core';
import { EventService } from './event.service';
import { SocketService } from './socket.service';
import { AuthService } from '../modules/auth/services/auth.service';
import { AppService } from './app.service';


/**
 * See doc here https://ionicframework.com/docs/api/util/Events/
 */
@Injectable()
export class GlobalEventService extends EventService {
  constructor(private zone: NgZone, private authService: AuthService) {
    super();
    try {
      if (!AppService.getEnvs('socket')) {
        return;
      }

      new SocketService(zone, this, authService);
    } catch (e) {
      console.error('Fail to initialize socket.io');
    }

  }
}
